import { Theme } from '@mui/material';
import { getAcornBoostBrand } from './brands/acorn';
import { getCarrotBoostBrand } from './brands/carrot';
import { BoostBrandConfig, BoostBrandFactory, BoostBrandKey } from './types';

const brandFactories: Partial<Record<BoostBrandKey, BoostBrandFactory | (() => BoostBrandConfig)>> = {
	acorn: getAcornBoostBrand,
	carrot: getCarrotBoostBrand,
};

export const getBoostBrandKey = (): BoostBrandKey => {
	const brand = import.meta.env.VITE_BOOST_AI_BRAND ?? 'acorn';

	switch (brand) {
		case 'acorn':
		case 'carrot':
		case 'flag':
		case 'motorcade':
		case 'mypolicy':
		case 'streetcover':
			return brand;
		default:
			return 'acorn';
	}
};

export const getBoostBrandConfig = (theme: Theme): BoostBrandConfig => {
	const factory = brandFactories[getBoostBrandKey()] ?? brandFactories.acorn;
	return factory!(theme);
};

export const buildChatPanelConfig = (theme: Theme, filter: string): NonNullable<BoostConfig['chatPanel']> => {
	const brand = getBoostBrandConfig(theme);

	return {
		header: {
			title: brand.title,
			filters: {
				filterValues: [filter],
			},
		},
		styling: brand.styling,
	};
};
